// Hangman page entry; the daily is one word per local date, the same for everyone.
import { HangmanGame } from "../hangman/ui"
import type { HangmanWord } from "../hangman/core"
import { fetchDaily, mountCalendar, pageDate, updateLabel } from "../lib/daily"

async function start(): Promise<void> {
  const board = document.getElementById("board")
  if (!board) return
  const game = board.dataset.dailyGame
  if (!game) {
    ;(window as unknown as { dtGame?: HangmanGame }).dtGame = new HangmanGame(board)
    return
  }
  const { date } = pageDate(board)
  updateLabel(date)
  let word: HangmanWord = { t: board.dataset.theme ?? "", w: board.dataset.word ?? "WORD" }
  if (date !== board.dataset.dailyDate) {
    const daily = await fetchDaily<{ word: HangmanWord }>(game, date)
    if (daily?.word) word = daily.word
  }
  ;(window as unknown as { dtGame?: HangmanGame }).dtGame = new HangmanGame(board, { game, date, word })
  mountCalendar(game, "/hangman")
}

void start()
